const getReactHtmlNodes = ({ blockId, reactId }) => {
    const nodeList = document.querySelectorAll(`[data-id="${blockId}"] [data-react-id="${reactId}"]`);

    if (nodeList.length > 0) {
        const nodes = [];

        for (let i = 0; i < nodeList.length; i++) {
            nodes.push(nodeList.item(i));
        }

        return nodes;
    }

    return [];
};

export const getBannerSSRHtmlNodes = banners => banners.reduce((acc, banner) => {
    const { html } = banner;
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(html, 'text/html');
    const ssrComponents = parsedDocument.getElementsByClassName('__react-root');

    const addedComponents = {};

    if (ssrComponents.length > 0) {
        for (let i = 0; i < ssrComponents.length; i++) {
            const componentToMount = ssrComponents.item(i);
            const { blockId, reactId } = componentToMount.dataset;

            if (blockId) {
                if (!addedComponents[blockId]) {
                    addedComponents[blockId] = [];
                }

                if (!addedComponents[blockId].includes(reactId)) {
                    addedComponents[blockId].push(reactId);
                    acc.push(...getReactHtmlNodes({ blockId, reactId }));
                }
            }
        }
    }

    return acc;
}, []);
